(() => {
  const d = document;

  function makeArrow(direction) {
    const b = d.createElement("button");
    b.type = "button";
    b.className = `gallery-arrow gallery-arrow-${direction}`;
    b.setAttribute(
      "aria-label",
      direction === "prev" ? "Previous image" : "Next image"
    );
    b.innerHTML =
      direction === "prev"
        ? '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 18l-6-6 6-6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 18l6-6-6-6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return b;
  }

  function getThumbButtons(gallery) {
    if (!gallery) return [];
    // Dawn: кнопки миниатюр имеют aria-controls="GalleryViewer-..."
    const btns = Array.from(
      gallery.querySelectorAll(
        'slider-component[id^="GalleryThumbnails"] button.thumbnail[aria-controls^="GalleryViewer-"], ' +
          'slider-component[id^="GalleryThumbnails"] button.thumbnail[aria-controls*="GalleryViewer-"]'
      )
    );
    return btns;
  }

  function getActiveIndex(btns) {
    if (!btns.length) return -1;

    // 1) чаще всего Dawn ставит aria-current="true"
    let idx = btns.findIndex((b) => b.getAttribute("aria-current") === "true");
    if (idx !== -1) return idx;

    // 2) иногда активный бывает по классу/состоянию в li
    idx = btns.findIndex((b) => b.closest("li")?.className?.includes("is-active"));
    if (idx !== -1) return idx;

    // 3) fallback: первый
    return 0;
  }

  function clickByIndex(btns, index) {
    if (!btns.length) return;
    const i = Math.max(0, Math.min(btns.length - 1, index));
    const btn = btns[i];
    if (!btn) return;

    // Важно: клик по миниатюре меняет главный слайд
    btn.click();

    // если миниатюры скроллятся — подвинем к активной
    try {
      btn.scrollIntoView({ block: "nearest", inline: "nearest" });
    } catch {}
  }

  function initOnPage() {
    const wrapper = d.querySelector(".product__media-wrapper");
    if (!wrapper) return false;

    if (wrapper.querySelector(".gallery-arrow")) return true;

    const mediaGallery =
      wrapper.closest("media-gallery") ||
      d.querySelector("media-gallery") ||
      wrapper.closest(".product__media-wrapper") ||
      d;

    // ensure position context
    const cs = window.getComputedStyle(wrapper);
    if (cs.position === "static") wrapper.style.position = "relative";

    const ourPrev = makeArrow("prev");
    const ourNext = makeArrow("next");
    wrapper.appendChild(ourPrev);
    wrapper.appendChild(ourNext);

    function step(dir) {
      const btns = getThumbButtons(mediaGallery);
      if (!btns.length) return;

      const active = getActiveIndex(btns);
      const nextIndex = dir === "prev" ? active - 1 : active + 1;

      // можно сделать “зацикливание”
      let target = nextIndex;
      if (target < 0) target = btns.length - 1;
      if (target >= btns.length) target = 0;

      clickByIndex(btns, target);
    }

    ourPrev.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      step("prev");
    });

    ourNext.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      step("next");
    });

    // если Shopify перерисует секцию (вариант/обновление) — стрелки останутся, логика берёт кнопки заново каждый клик
    return true;
  }

  function boot() {
    if (initOnPage()) return;

    const mo = new MutationObserver(() => {
      if (initOnPage()) mo.disconnect();
    });

    mo.observe(d.documentElement, { childList: true, subtree: true });
    setTimeout(() => mo.disconnect(), 15000);
  }

  if (d.readyState === "loading") d.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
